import React, { useEffect } from 'react';
import { AppRoutes } from './AppRoutes';
import './App.css';
import './Assets/Css/Common.css';
import ToasterComponent from './Components/UI/toaster';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  useEffect(() => {
    // Clear the error-boundary loop guard once the app mounts cleanly.
    sessionStorage.removeItem('errorRedirect');
  }, []);

  return (
    <div className="App">
      <AppRoutes />
      <ToasterComponent />
    </div>
  );
}

export default App;
